import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5fa5fe65&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./index.vue?vue&type=style&index=0&id=5fa5fe65&prod&scoped=true&lang=scss")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "5fa5fe65",
  "dbcac060"
  
)

export default component.exports